<template>
  <el-card>
    <template #header>
      <el-form inline>
        <el-form-item :label="`${$t('名称')}：`">
          <span>{{ detailInfo.treeName || "" }}</span>
        </el-form-item>
        <el-form-item :label="`${$t('图片')}：`">
          <preview-img :img-url="detailInfo.photo" width="100px" height="100px"  />
        </el-form-item>
      </el-form>
    </template>

    <div class="row">
      <div class="flex">
        <h4>{{$t('营养成分')}}</h4>
        <span>{{$t('（100g食物所包含营养成分）')}}</span>
      </div>

      <div>
        <el-button size="small" type="primary" @click="handleSaveSubmit">{{$t('保存更改')}}</el-button>
        <el-button size="small" type="primary" @click="handleGoElManager">{{$t('编辑元素')}}</el-button>
        <el-button size="small" type="primary" @click="handleClearContent">{{$t('默认含量一键清零')}}</el-button>
      </div>
    </div>

    <el-form inline size="small">
      <el-form-item :label="$t('营养素名称')">
        <el-input v-model="searchForm.name" :placeholder="$t('营养素名称')"/>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="$refs.list.handleSearch()">{{$t('查询')}}</el-button>
        <el-button @click="$refs.list.reset()">{{$t('重置')}}</el-button>
      </el-form-item>
    </el-form>

    <table-list
        :show-page="false"
        ref="list"
        @query="loadElList"
        :search-params="searchForm"
        :request-params="{foodCode: $route.query.code}"
        :data="tableData"
        :on-page="false"
        row-key="id"
        :tree-props="{children: 'children'}"
        :indent="16"
        @selection-change="selection = $event">

      <el-table-column type="selection" width="50"/>
      <el-table-column type="index" :label="$t('序号')" width="50"/>
      <el-table-column prop="elementName" :label="$t('营养素')"/>
      <el-table-column prop="content" :label="$t('含量/默认值')">
        <template v-slot="{row}">
          <el-input style="max-width: 200px" v-model="row.content" />
        </template>
      </el-table-column>
      <el-table-column prop="" :label="$t('默认展开')">
        <template v-slot="{row}">
          <el-switch inactive-value="no" active-value="yes" v-model="row.expand" />
        </template>
      </el-table-column>
      <el-table-column prop="display" :label="$t('默认展示')">
        <template v-slot="{row}">
          {{row.display === 'yes' ? $t('是') : $t('否')}}
        </template>
      </el-table-column>
      <el-table-column :label="$t('操作')">
        <template v-slot="{row}">
          <el-link :underline="false" type="danger" @click="handleDelete(row)">{{$t('删除')}}</el-link>
        </template>
      </el-table-column>
    </table-list>

    <select-el-table ref="selectElTable" :list="tableData" :food-code="$route.query.code" @refresh="$refs.list.handleSearch()" />
  </el-card>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request} from "@/config/request";
import PreviewImg from "@/components/preview-img/PreviewImg.vue";
import SelectElTable from "@/components/select-el-table/SelectElTable.vue";

export default {
  name: "AddFoodEl",
  components: {SelectElTable, PreviewImg, TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
      detailInfo: []
    }
  },
  methods: {
    // 清零含量
    handleClearContent() {
      this.$confirm(this.$t('确定一键回复默认值吗？'), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消'),
        type: 'warning'
      }).then(async () => {

        const fn = (list) => {
          list.forEach(item => {
            item.content = 0;
            if(item.children.length) fn(item.children);
          })
        }
        fn(this.tableData);
        this.handleSaveSubmit();
      })
    },

    // 删除树节点
    handleDeleteTreeNode(ids, source) {
      // 过滤掉被删除的row
      const fn = (list) => {
        return list.filter(item => {
          if (item.children && item.children.length) {
            item.children = fn(item.children);
          }
          return !ids.includes(item.id);
        })
      }
      return fn(source);
    },

    async handleDelete(row) {
      try {
        this.$confirm(this.$t('删除后不可恢复，确认删除？'), this.$t('提示'), {
          confirmButtonText: this.$t('确定'),
          cancelButtonText: this.$t('取消'),
          type: 'warning'
        }).then(async () => {
          await request(this.$api.foodElement.delete, {code: row.code});
          this.$refs.list.handleRequest(1);
          this.$message.success(this.$t('操作成功'));
        })
      } catch (e) {
        console.error(e);
      }
    },


    handleGoElManager() {
      this.$refs.selectElTable.handleShowDialog();
      /*this.$router.push({
        path: '/food/el',
        query: this.$route.query,
      })*/
    },

    // 保存提交
    async handleSaveSubmit() {
      try {
        const codes = this.handleGetSelectCodes(this.selection);
        const sortList = this.handleSortList([...this.tableData], codes);
        const params = this.handleFormatSubmitData(sortList);
        await request(this.$api.foodElement.save, params, {isJson: true});
        this.$message.success(this.$t('保存成功'));
        this.$refs.list.handleSearch();
      }catch(e) {
         console.log(e);
      }
    },

    // 格式化提交数据
    handleFormatSubmitData(target) {
      const foodCode = this.$route.query.code;
      const fn = (list) => {
        return list.map((item, index) => {
          let children = [];
          if(item.children.length) {
            children = fn(item.children);
          }
          return {
            code: item.code,
            foodCode,
            elementCode: item.elementCode,
            content: item.content,
            expand: item.expand,
            display: item.display,
            sort: index + 1,
            foodElementBeans: children,
          }
        })
      }
      const foodElementBeans = fn(target);
      return {
        foodCode,
        foodElementBeans
      }
    },

    // 获取选择的code/包括父级
    handleGetSelectCodes(list) {
      const codes = new Set();
      list.forEach(item => {
        if(item.pid) codes.add(item.pid);
        codes.add(item.id);
      })
      return [...codes];
    },

    // 根据勾选选中排序
    handleSortList(target, selectionCode) {
      const fn = (list) => {
        const selection = [];
        // 先循环找出当前层级存在选中的
        list.forEach((item) => {
          if (item.children.length) {
            item.children = fn(item.children);
          }

          if (selectionCode.includes(item.id)) {
            selection.push(item);
          }
        })

        // 当前层级有选中的，则删除选中的，并把选中的添加到最前面
        if (selection.length) {
          selection.forEach(s => {
            list.splice(list.indexOf(s), 1);
          })
          list = [...selection, ...list];
        }
        return list;
      }
      return fn(target);
    },

    // 元素列表
    async loadElList(params) {
      try {
        const res = await request(this.$api.foodElement.list, params);
        const list = this.handleBuildTreeData(res.foodElements);
        this.tableData = list;
      } catch (e) {
        console.log(e);
      }
    },


    handleBuildTreeData(list) {
      return list.map(item => {
        let children = [];
        if (Array.isArray(item.sub) && item.sub.length) {
          children = this.handleBuildTreeData(item.sub);
        }

        return {
          // 以下为表格字段
          ...item,
          content: item.content || 0.0,

          pid: item.parentCode, // 父级id/code
          id: item.code, // 当前id/code
          isFirstRow: !item.parentCode, // 是否一级
          children, // 子集
        }
      })
    },




    async handleLoadDetail() {
      try {
        const res = await request(this.$api.foodSort.detail, this.$route.query);
        this.detailInfo = res.foodSort;
      } catch (e) {
        console.log(e);
      }
    },
  },
  created() {
    this.handleLoadDetail();
  }
}
</script>

<style scoped>

.row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.cover {
  border-radius: 12px;
  width: 100px;
  height: 100px;
}

/deep/ .cell {
  display: flex;
  align-items: center;
}


</style>
